import { defaultFill } from '../../utils/constants';
var muiSuccessOutline16 = {
    paths: [
        {
            path: 'M8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 Z M8,2 C4.6862915,2 2,4.6862915 2,8 C2,11.3137085 4.6862915,14 8,14 C11.3137085,14 14,11.3137085 14,8 C14,4.6862915 11.3137085,2 8,2 Z M10.4748737,4.81801948 L11.8890873,6.23223305 L6.93933983,11.1819805 L4.1109127,8.35355339 L5.52512627,6.93933983 L6.93933983,8.35355339 L10.4748737,4.81801948 Z',
            fill: defaultFill,
        },
    ],
    title: 'Success',
    width: 16,
    height: 16,
};
var muiSuccessOutline24 = {
    paths: [
        {
            path: 'M11,0 C17.0751322,0 22,4.92486775 22,11 C22,17.0751322 17.0751322,22 11,22 C4.92486775,22 0,17.0751322 0,11 C0,4.92486775 4.92486775,0 11,0 Z M11,2 C6.02943725,2 2,6.02943725 2,11 C2,15.9705627 6.02943725,20 11,20 C15.9705627,20 20,15.9705627 20,11 C20,6.02943725 15.9705627,2 11,2 Z M14.8181818,6 L17,8.18222215 L9.36363636,15.8199997 L5,11.4555554 L7.18181818,9.27333323 L9.36363636,11.4555554 L14.8181818,6 Z',
            fill: defaultFill,
        },
    ],
    title: 'Success',
    width: 22,
    height: 22,
};
var muiSuccessOutline = {
    base: muiSuccessOutline16,
    smIcon: muiSuccessOutline16,
    lgIcon: muiSuccessOutline24,
};
export { muiSuccessOutline };
//# sourceMappingURL=successOutline.js.map